export const MachineApprovalStatus = {
  APPROVAL: 'APPROVAL',
  PSWAITING: 'PSWAITING',
  WAITING: 'WAITING',
  REJECT: 'REJECT',
} as const;

export type MachineApprovalStatusType = typeof MachineApprovalStatus;
